<template>
  <ais-hierarchical-menu
    :attributes="attributes"
    :root-path="rootPath"
    :limit="limit"
    :transform-items="transformItems"
  >
    <template #default="{ items, refine, createURL }">
      <div
        :class="{
          'list-wrapper': showTitle,
          open: showList,
        }"
      >
        <router-link
          v-if="showTitle"
          :to="getURL({ section }, ['category', 'subcategory'])"
          class="section-title"
        >
          <strong>
            {{ title }}
          </strong>
          <IconChevronRight v-if="!showList" />
          <IconChevronDown v-else />
        </router-link>

        <!-- List -->
        <div
          :class="{
            'ms-3': showTitle,
          }"
        >
          <span v-if="showList && (!items || items.length === 0)">
            {{ gettext('No results in') }} '{{ title }}'
          </span>
          <hierarchical-menu-list
            v-if="showList"
            :items="items"
            :refine="refine"
            :createURL="createURL"
            @onSelectItem="$emit('onSelectItem', $event)"
            :class="listClass"
            :subListClass="subListClass"
          />
        </div>
      </div>
    </template>
  </ais-hierarchical-menu>
</template>

<script>
import { AisHierarchicalMenu } from 'vue-instantsearch';
import HierarchicalMenuList from './HierarchicalMenuList.vue';
import IconChevronRight from '../../../../templates/icons/chevron-right.svg';
import IconChevronDown from '../../../../templates/icons/chevron-down.svg';
import { updateUrlQuery } from '../util/url';

export default {
  components: {
    AisHierarchicalMenu,
    IconChevronRight,
    IconChevronDown,
    HierarchicalMenuList,
  },
  props: {
    title: String,
    section: String,
    showTitle: Boolean,
    showList: Boolean,
    attributes: Array,
    rootPath: String,
    limit: {
      type: Number,
      default: 10,
    },
    listClass: String,
    subListClass: String,
    transformItems: Function,
    clearRefinementAttributes: Array,
  },
  methods: {
    getURL(add, remove) {
      return updateUrlQuery({
        path: this.$route.fullPath,
        add,
        remove,
      });
    },
  },
};
</script>
